import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textbox: {
      width: "100%",
    },
    btnContainer: {
        textAlign: 'right'
    },
    clearButton: {
        height: "100%"
    }
  })
);
